import { Paper, Typography, Stack, Avatar, alpha } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { SideMenuIcon } from "../../assets";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme, props) => ({
  paper: {
    flexGrow: 1,
    minHeight: 50,
    "&.MuiPaper-root": {
      // borderRadius: 0,
      padding: theme.spacing(2),
    },
  },
  counterText: {
    "&.MuiTypography-root": {
      fontSize: 18,
      fontWeight: 600,
    },
  },
  titleText: {
    "&.MuiTypography-root": {
      fontSize: 16,
      fontWeight: 400,
    },
  },
  avatarImage: {
    "&.MuiAvatar-root": {
      width: 55,
      height: 55,
    },
  },
}));

export function CounterCard(props) {
  const classes = useStyles(props);
  const { id, title, count, icon, color } = props;

  return (
    <Paper className={classes.paper} key={id}>
      <Stack direction="row" spacing={2}>
        <Avatar
          className={classes.avatarImage}
          sx={{ bgcolor: alpha(color, 0.1) }}
        >
          <SideMenuIcon name={icon} color={color} size={30} />
        </Avatar>
        <Stack>
          <Typography className={classes.counterText}>{count}</Typography>
          <Typography className={classes.titleText}>{title}</Typography>
        </Stack>
      </Stack>
    </Paper>
  );
}

CounterCard.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  count: PropTypes.number,
  icon: PropTypes.string,
  color: PropTypes.string,
};
